export default __webpack_public_path__ + "static/media/jumpGame.a21b5e4a.png";